import { config } from "../config.js";

export const TIERS = [
  { id: "tier35", price: config.tierPrice1 || 35, tributes: 5, description: "Yard Sign & 5 Teacher/Staff Tributes" },
  { id: "tier40", price: config.tierPrice2 || 40, tributes: 10, description: "Yard Sign & 10 Teacher/Staff Tributes" },
];

export const YARD_SIGN_OPTIONS = [
  "I Step Up for Teachers",
  "Congratulations 2026 Graduate",
];
